import Stack from "@mui/material/Stack";

import { NavBar, Hero, HeroContent } from "@/components/ui";
import { hero } from "@/constants";

type HeaderProps = {
  pathname: string;
};

export const Header = ({ pathname }: HeaderProps) => {
  const pageKey = pathname.split("/")[0] || "home";
  const pageHero = hero[pageKey as keyof typeof hero];
  const isBooking = pathname.includes("booking");
  const hasHero = Boolean(pageHero?.img) && !isBooking;

  return (
    <Stack>
      {hasHero && pageHero && (
        <Hero background={pageHero.img}>
          <HeroContent hero={pageHero} />
        </Hero>
      )}
      <NavBar />
    </Stack>
  );
};
